var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        title: "Plan İptali",
        "cancel-text": "Vazgeç",
        "ok-text": "Onayla",
        "show-footer": true,
      },
      on: { ok: _vm.confirm, cancel: _vm.close },
    },
    [
      _vm._v(
        "\n    Plan iptali gerçekleştikten sonra paket kullanımınız ay başına kadar devam edecektir. İptal etmek istediğinizden\n    emin misiniz?\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }